import "./login/login.css";
import { Button, Heading } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export const Welcome = () => {
  const navigate = useNavigate();

  return (
    <div className="login-container">
      <img src={"/img/logo.png"} alt="logo"/>

      <Heading size="md" margin="15px" fontWeight="normal">Welcome To Dolphin</Heading>

      <Button
        width="60%"
        color="rgb(233,193,77)"
        onClick={() => navigate("/")}
        backgroundColor="rgb(21,95,93)"
        margin="50px"
      >
        Continue To Home Page
      </Button>
    </div>
  );
};
